import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import {
  getCodeTranslation,
  getCompany,
  listPlaceOfSupply,
  listUserCompanies,
} from "../../graphql";
import { PURGE } from "redux-persist";
import { showErrorSnackbar } from "../../components/snackBar/snakbar";

export const fetchCountryList = createAsyncThunk("countryList", async () => {
  const countries = await API.graphql(
    graphqlOperation(getCodeTranslation, { codetype: "Country" })
  );
  if (countries?.data) return countries?.data;
});

const INITIAL_STATE = {
  countryList: [],
  render: true,
  Loaded: false,
  loading: false,
};
const CountryList = createSlice({
  name: "country",
  initialState: INITIAL_STATE,
  reducers: {
    setCountryList(state, action) {
      state.countryList = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchCountryList.pending, (state) => {
        state.Loaded = false;
      })
      .addCase(fetchCountryList.fulfilled, (state, action) => {
        if (action?.payload) {
          return {
            ...state,
            countryList: action.payload,
            Loaded: true,
          };
        } else {
          state.Loaded = true;
        }
      })
      .addCase(fetchCountryList.rejected, (state) => {
        state.Loaded = false;
        showErrorSnackbar("Network Error !");
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const { setCountryList } = CountryList.actions;
export default CountryList.reducer;
